import { InspectionItem } from '@editor/interfaces/inspection'
import { batchDeleteInspectionItems, patchInspectionItems, postInspectionItems } from '@editor/services/InspectionSheet'
import { createAsyncThunk } from '@reduxjs/toolkit'

/**
 * Update existing polylines.
 */
export const updatePolylines = createAsyncThunk(
  'editor/tools/polyline/patch',
  async ({
    accessToken,
    projectId,
    items,
    showErrorModal,
  }: {
    accessToken: string
    projectId: string
    items: Partial<InspectionItem>[]
    showErrorModal?: (message: string) => void
  }) => patchInspectionItems(accessToken, projectId, items, showErrorModal),
)

/**
 * Delete existing polylines.
 */
export const deletePolylines = createAsyncThunk(
  'editor/tools/polyline/delete',
  async ({
    accessToken,
    projectId,
    areaId,
    sheetId,
    items,
    showErrorModal,
  }: {
    accessToken: string
    projectId: string
    areaId: string
    sheetId: string
    items: string[]
    showErrorModal?: (message: string) => void
  }) => batchDeleteInspectionItems(accessToken, projectId, areaId, sheetId, items, showErrorModal),
)

/**
 * Add polyline widths to an existing polyline.
 */
export const addPolylineWidths = createAsyncThunk(
  'editor/tools/polyline/addWidths',
  async ({
    accessToken,
    projectId,
    inspectionAreaId,
    inspectionSheetId,
    items,
    showErrorModal,
  }: {
    accessToken: string
    projectId: string
    inspectionAreaId: string
    inspectionSheetId: string
    items: Partial<InspectionItem>[]
    showErrorModal?: (message: string) => void
  }) => postInspectionItems(accessToken, projectId, inspectionAreaId, inspectionSheetId, items, showErrorModal),
)
